import Header from "./Header";
import Footer from "./Footer";

export default function MarketingLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#F9F8F6]">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
